import { render, staticRenderFns } from "./InviteUser.vue?vue&type=template&id=72a35f9f&scoped=true&"
import script from "./InviteUser.vue?vue&type=script&lang=js&"
export * from "./InviteUser.vue?vue&type=script&lang=js&"
import style0 from "./InviteUser.vue?vue&type=style&index=0&id=72a35f9f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a35f9f",
  null
  
)

export default component.exports